var _effectorFileName = "/builds/gmini/front-common/src/components/LoadingPage.tsx";
import { memo } from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@gmini/ui-kit/lib/CircularProgress';
import { jsx as _jsx } from "react/jsx-runtime";
export var LoadingPage = /*#__PURE__*/memo(function () {
  return /*#__PURE__*/_jsx(Main, {
    children: /*#__PURE__*/_jsx(Content, {
      children: /*#__PURE__*/_jsx(CircularProgress, {})
    })
  });
});
LoadingPage.displayName = 'LoadingPage';
var Main = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
});
var Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});